/**
 * Get Click ID for Booking Submission
 *
 * Returns the cb_amp_click_id value to include in the booking submission to /prepare.
 * This integrates with the existing flow where the backend's concludeYourAmplifyClickIDJourney()
 * handles sending data to cbtrk.adshotel.com.
 */
import { formatClickDataForBackend, getValidClickData, } from './clickTrackerStorage';
/**
 * Get the cb_amp_click_id value to include in booking submission
 *
 * Returns null if:
 * - No click data exists in localStorage for this property
 * - Click data is older than 30 days
 *
 * @param propertyCode The property code from URL (e.g., "v0nsqg") for which to get the click data
 * @returns The cb_amp_click_id string or null
 */
export function getClickIdForBooking(propertyCode) {
    try {
        // Get valid click data for this specific property (only if within 30 days)
        const clickData = getValidClickData(propertyCode);
        if (!clickData) {
            return null;
        }
        return formatClickDataForBackend(clickData);
    }
    catch (error) {
        console.error('[ClickTracker] Error getting click ID for booking:', error);
        return null;
    }
}
